angular
  .module('common.directives')
  .directive('healthReportsHealth', function () {
    return {
      templateUrl:
        './templates/health-reports/health-reports-health.view.html?t=' +
        webpackHash,
      link: function ($scope, $element) {},
      controller: 'healthReportsHealthController'
    }
  })
